import { TaxIdStatusDescription } from '@/types/enums';

export type PersonTaxIdStatusPresentation = {
  className: string;
  icon?: string;
};

const defaultStatusPresentation: PersonTaxIdStatusPresentation = {
  className: 'text-gray-600 font-semibold',
};

const statusPresentationByDescription: Partial<Record<TaxIdStatusDescription, PersonTaxIdStatusPresentation>> = {
  [TaxIdStatusDescription.REGULAR]: {
    className: 'text-green-400 font-semibold',
    icon: 'check_circle',
  },
  [TaxIdStatusDescription.DECEASED_HOLDER]: {
    className: 'text-white bg-red-400 px-2 py-1 rounded-md font-semibold',
    icon: 'warning',
  },
  [TaxIdStatusDescription.CANCELED]: {
    className: 'text-white bg-red-400 px-2 py-1 rounded-md font-semibold',
    icon: 'block',
  },
  [TaxIdStatusDescription.PENDING_REGULARIZATION]: {
    className: 'text-white bg-amber-400 px-2 py-1 rounded-md font-semibold',
    icon: 'warning',
  },
  [TaxIdStatusDescription.SUSPENSA]: {
    className: 'text-white bg-amber-400 px-2 py-1 rounded-md font-semibold',
    icon: 'warning',
  },
  [TaxIdStatusDescription.NULL]: {
    className: 'text-gray-400 font-semibold',
    icon: 'help',
  },
  [TaxIdStatusDescription.CPF_NOT_FOUND_IN_RECEITA]: {
    className: 'text-white bg-gray-500 px-2 py-1 rounded-md font-semibold',
    icon: 'person_off',
  },
};

export const getPersonTaxIdStatusPresentation = (
  status: TaxIdStatusDescription | undefined,
): PersonTaxIdStatusPresentation => {
  if (!status) return defaultStatusPresentation;
  return statusPresentationByDescription[status] ?? defaultStatusPresentation;
};
